<template lang="pug">
  .home-slider(:class="{'transparent': (fullTransparent)}")
    .next(:style="{'background-image': `url(${nextImage})`}")
    .current(:style="{'background-image': `url(${currentImage})`}" :class="{'transparent': (transparent)}")
</template>

<script>
import {mapActions} from 'vuex'

export default {
  name: 'slider',
  data () {
    return {
      images: [],
      timer: 300,
      index: 0,
      transparent: false,
      fullTransparent: true,
      interval: null
    }
  },
  methods: {
    ...mapActions(['getHomeSlides']),
    runLoop () {
      this.interval = setInterval(() => {
        this.changeSlide()
      }, this.timer)
    },
    changeSlide () {
      this.transparent = true
      setTimeout(() => {
        this.transparent = false
        if (this.index === this.images.length - 1) {
          this.index = 0
        } else {
          this.index++
        }
      }, 300)
    }
  },
  computed: {
    currentImage () {
      return (this.images[this.index] || {}).img
    },
    nextImage () {
      if ((this.images[this.index + 1] || {}).img) {
        return (this.images[this.index + 1] || {}).img
      }
      return (this.images[0] || {}).img
    }
  },
  created () {
    setTimeout(() => {
      this.getHomeSlides().then((res) => {
        this.images = res.images
        if (res.timer > 0.3) {
          this.timer = res.timer * 1000
        }
        this.runLoop()
        this.fullTransparent = false
      })
    }, 5000)
  },
  destroyed () {
    clearInterval(this.interval)
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/home/parts/slider/index.vue